import React from 'react';

import Select from "../../components/form/Select";
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Btvoltar from '../../components/buttons/Btvoltar';
import ESTADOS from './../../data/estados';

import DAYS from './../../data/Days';
import ONDE_TREINA from './../../data/Onde_treina';
import TEMPO_MUSCULACAO from './../../data/TempoMusculacao';
import TIPOS_PLANILHA from './../../data/TiposPlanilha';

import Page from './Page';

import Modal from '../../components/modal/Modal';

class FormTreino extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      ...props.dados,
      strings:STRINGS[window.LANGUAGE],
      statusTipoTreino: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeStep = this.changeStep.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.openObjetivo = this.openObjetivo.bind(this);
    this.backStep = this.backStep.bind(this);
  }

  backStep(e){
    e.preventDefault();
    this.changeStep(this.props.step-1);
  }

  handleSubmit(){
    const { tipo_treino, onde_treina, qtd_dias, tempo_musculacao } = this.state;
    const {
      atencao,
      preenchaCamposAsterisco
    }
    = this.state.strings;

    if( tipo_treino && onde_treina && qtd_dias && tempo_musculacao){
      this.props.changeStep({ step:(this.props.step+1) });
    }else{
      const msg = {
        title: atencao,
        text: preenchaCamposAsterisco
      };
      Dialog.create(msg);
    }
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

    this.props.changeData({name, value});
  }

  changeStep(step) {
    this.props.changeStep({ step:step });
  }

  openObjetivo(e) {
    var modal = new Modal();
    modal.open({page:<Page modal={modal} />});

    e.preventDefault();
  }

  handleSelect (type, __args__){
    const obj = {};
    //se o treino for casa, o tipo de treino é necessariamente Emagrecimento
    if(type === 'onde_treina' && __args__.value === 'casa'){
      obj[type] =__args__.value;
      obj.statusTipoTreino = true;
      obj.tipo_treino = 'E';
      //changeForm('E', 'tipo_treino' );

      const {
        atencao,
        treinoCasaTxt
      }
      = this.state.strings;
      Dialog.create({
        title: atencao,
        text: treinoCasaTxt
      });

    }else{
      obj[type] =__args__.value;
      obj.statusTipoTreino = false;
    }

    //previne que o select de O que procura?* apareça ao usar outro select
    if(this.state.statusTipoTreino && !obj.statusTipoTreino && type !== 'onde_treina'  ){
      obj.statusTipoTreino = true;
    }

    this.setState({...obj});

    this.props.changeData({name: type, value:__args__.value });
    //changeForm(__args__.value, type );
  }

  getItemSelect(__args__) {
    const check = __args__.value;
    let resp;
    const arr = __args__.arr;
    arr.map((value,i)=>{
      if(value.value === check){
        resp = arr[i];
        return false;
      }
    });
    return resp;
  }

  render(){
    const strings = this.state.strings;

    //-----
    const tipo_treino = this.getItemSelect({
      value: this.state.tipo_treino,
      arr: TIPOS_PLANILHA});

    const onde_treina = this.getItemSelect({
      value: this.state.onde_treina,
      arr: ONDE_TREINA});

    const qtd_dias = this.getItemSelect({
      value: this.state.qtd_dias,
      arr: DAYS});

    const tempo_musculacao = this.getItemSelect({
      value: this.state.tempo_musculacao,
      arr: TEMPO_MUSCULACAO});
    //------

    const statusTipoTreino = this.state.statusTipoTreino ? null :
    (
      <div>
        <Select
          isSearchable={false}
          key={Math.random()}
          name='tipo_treino'
          onChange={(e)=>this.handleSelect('tipo_treino',e)}
          title={`${strings.txtTipoTreino}*`}
          options={TIPOS_PLANILHA}
          value={tipo_treino}
        />
      <a href='#' onClick={this.openObjetivo} className='btObjetivo'>{strings.btObjetivo}</a>
      </div>
    );

    return(
      <div  className='box-formulario'>
        <div className='box-title'>
          {/*<span className='cadastro-title'><strong>Cadastro - </strong>1 de 3</span>*/}
          <span className='title-box-title'>{strings.meuTreino}</span>
        </div>
        <div>
          <Select
            isSearchable={false}
            key={Math.random()}
            name='onde_treina'
            onChange={(e)=>this.handleSelect('onde_treina',e)}
            title={`${strings.txtOndeTreina}*`}
            options={ONDE_TREINA}
            value={onde_treina}
          />
          {statusTipoTreino}

          <div className='pure-u-g'>
            <div className="pure-u-1 pure-u-md-1-2">
              <TextInput
                value={this.state.peso}
                name="peso"
                inputMask={{
                  name:'peso',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                type='number'
                maxlength="4"
                title={`${strings.fieldPeso}*`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
            <div className="pure-u-1 pure-u-md-1-2">
              <TextInput
                value={this.state.altura}
                name="altura"
                inputMask={{
                  name:'altura',
                  placeholder: '',
                  mask: "999",
                  maskChar: ""
                }}
                type='number'
                maxlength="4"
                title={`${strings.fieldAltura}`}
                onChange={this.handleInputChange}
                placeholder=''>
              </TextInput>
            </div>
          </div>



          <Select
            isSearchable={false}
            key={Math.random()}
            name='qtd_dias'
            onChange={(e)=>this.handleSelect('qtd_dias',e)}
            title={`${strings.txtQuantidadeDias}*`}
            options={DAYS}
            value={qtd_dias}
          />
          <Select
            isSearchable={false}
            key={Math.random()}
            name='tempo_musculacao'
            onChange={(e)=>this.handleSelect('tempo_musculacao',e)}
            title={`${strings.txtTempoMusculacao}*`}
            options={TEMPO_MUSCULACAO}
            value={tempo_musculacao}
          />
          <div className='field-mandatory'>{strings.camposObrigatorios}</div>
          <div className="box-center-button">
            <Button text={strings.txtContinuar} onClick={this.handleSubmit} type='button' classes="button-login simple-button" />
            <Btvoltar text='Voltar' onClick={this.backStep} />
        </div>
        </div>
      </div>
    )
  }
}

export default FormTreino;



// WEBPACK FOOTER //
// ./src/classes/cadastro/FormTreino.js